import React from 'react';
import {Box} from '@mui/material';
import {ONBOARDING_STEPS, OnboardingStep} from '../onboardingSteps';
import styles from '../onboardingWizard.module.scss';

type StepData = {
  title: string;
  description: string;
  renderImage: () => React.ReactNode;
};

const FEATURE_SELECTION_ASSET_URL =
  'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Unselected.mp4';

function FeatureSelectionVideo() {
  return (
    <Box
      width="100%"
      height="100vh"
      sx={{backgroundColor: '#E5E3F4'}}
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="relative"
    >
      <Box
        component="video"
        src={FEATURE_SELECTION_ASSET_URL}
        autoPlay
        loop
        muted
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          objectFit: 'cover',
        }}
        style={{
          width: '100%',
          height: '100vh',
        }}
      />
    </Box>
  );
}

export default function getStepData(step: OnboardingStep): StepData {
  const getStepDataByStepMap = {
    [ONBOARDING_STEPS.CONSENT_FORM]: {
      title: 'Review Ltx Scaler’s Terms',
      description: '',
      renderImage: () => (
        <img
          src="/assets/images/content-studio/onboarding/content-agreement-wide.jpg"
          alt="Content agreement"
          className={styles.desktopVisual}
        />
      ),
    },
    [ONBOARDING_STEPS.USER_TYPE_SELECTION]: {
      title: '',
      description: '',
      renderImage: () => (
        <img
          src="/assets/images/content-studio/onboarding/preferred-industries-wide.jpg"
          alt="User type selection"
          className={styles.desktopVisual}
        />
      ),
    },
    [ONBOARDING_STEPS.FEATURE_SELECTION]: {
      // title: translate('What do you want to do first?'),
      // description: translate('Choose a tool to kick off your first project'),
      title: '',
      description: '',
      renderImage: () => <FeatureSelectionVideo />,
    },
  };
  return getStepDataByStepMap[step];
}
